/* eslint-disable react/no-danger */
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Container, HeaderProfile } from '@presentation/components';
import type { QRCodePageProps } from './types';
import * as Styled from './styled';

export * from './types';

export const QRCodePage: FC<QRCodePageProps> = (props) => {
  const { translate } = useTranslation();
  const { id } = props;
  const title = translate(`qrcode.code${id}.title`);
  const subTitle = translate(`qrcode.code${id}.subTitle`);
  const content = translate(`qrcode.code${id}.content`);

  return (
    <>
      {title?.length > 2 ? (
        <HeaderProfile title={title} {...(subTitle?.length > 2 && { subtitle: subTitle })} />
      ) : null}
      <Container>
        <Styled.Content dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </>
  );
};
